package music.jammers.client.shared.component.avatar.presentation.ui

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import coil3.compose.AsyncImage
import music.jammers.client.shared.component.avatar.di.AvatarImageDiComponent
import music.jammers.client.shared.component.avatar.presentation.viewmodel.AvatarImageViewModel

@Composable
fun AvatarImageComponent() {
    val viewModel: AvatarImageViewModel = remember { AvatarImageDiComponent().viewModel.apply { onReady() } }

    val state = viewModel.state.value

    state.user?.let { user ->
        Box(
            modifier = Modifier.padding(8.dp)
                .clip(shape = CircleShape)
                .clickable {
                    viewModel.onAvatarClicked()
                }
        ) {
            AsyncImage(
                model = user.pictureUrl,
                contentDescription = "user_picture",
                contentScale = ContentScale.Crop,
                modifier = Modifier.size(40.dp).align(Alignment.Center),
            )
        }
    }
}